import { Typography } from '@mui/material';

import Grid from 'components/core/Grid';
import { alluraAddress, alluraPhone } from 'config/company';

export const ListFooterBar = () => {
  return (
    <>
      <Grid item xs={12}>
        <br />
      </Grid>
      <Grid item xs={12} align="center">
        <Typography variant="body2">
          ©{new Date().getFullYear()} alluraDirect.com <a href={`https://${process.env.NEXT_PUBLIC_BASE_URL}`}>Vacation Rentals and Accommodations</a>
        </Typography>
        <Typography variant="caption">
          {alluraAddress} {alluraPhone}
        </Typography>
      </Grid>
    </>
  );
};
